import React from 'react'
import './Appspage.css'

function Appspage() {
  return (
    <div>
        <div className="appspage-container">
          
            This is apps page
        </div>
      
    </div>
  )
}

export default Appspage;
